import { createStore, setStateHelper } from "@neonumy/ant-design";
import { StoreApi, UseBoundStore } from "zustand";

const initialState = {
  userData: undefined,
};

interface AuthStore {
  resetStore: () => void;
  userData: UserDataType | undefined;
  setUserData: (userData: UserDataType) => void;
}

const useAuthStore: UseBoundStore<StoreApi<AuthStore>> = createStore<AuthStore>(
  (set: (fn: (draft: Record<string, any>) => void) => void) => ({
    ...initialState,
    resetStore: () => {
      set(() => ({
        ...initialState,
      }));
    },
    setUserData: (userData: UserDataType) => {
      setStateHelper("userData", userData, set);
    },
  }),
);

export default useAuthStore;
